import React from 'react';
import routinesImg from '../assets/mascots/routines.png';
import quickstartImg from '../assets/mascots/quickstart.png';
import historyImg from '../assets/mascots/history.png';
import shopImg from '../assets/mascots/shop.png';

const ICON_SIZE = 36;

// Hover title on the mascot box, for all four variants -- doubles as a dev
// identifier back when some variants were still placeholder icons.
const MASCOT_LABELS = {
  routines: "Routines",
  quickstart: "Quick Start",
  history: "Previously...",
  shop: "Shop",
  exercises: "Manage My Exercises"
};

// Real per-variant mascot art. All four top-level panels have their own
// image now; any future variant not listed here (e.g. "exercises") falls
// back to a placeholder icon below.
const MASCOT_IMAGES = {
  routines: routinesImg,
  quickstart: quickstartImg,
  history: historyImg,
  shop: shopImg
};

// Per-variant fallback icon (filled shape, no real photo art yet) for
// variants not in MASCOT_IMAGES. "exercises" gets a plain three-bar list
// glyph (matches the "black list icon" ask directly, rather than the
// generic person-silhouette every other not-yet-imaged variant used to
// fall back to before real art existed for them).
const MASCOT_FALLBACK_ICONS = {
  exercises: (
    <>
      <rect x="4" y="5" width="16" height="2.5" rx="1" />
      <rect x="4" y="10.75" width="16" height="2.5" rx="1" />
      <rect x="4" y="16.5" width="16" height="2.5" rx="1" />
    </>
  )
};
const DEFAULT_FALLBACK_ICON = (
  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
);

/**
 * Mascot portrait: sits beside a panel's title (see CategoryPanel.jsx),
 * sized in CSS to fill 90% of the collapsed panel's height, bleeding flush
 * to the panel's top/bottom/left border. Renders real art via MASCOT_IMAGES
 * when the variant has it (object-fit: cover fills the box exactly,
 * cropping as needed); otherwise falls back to the placeholder icon.
 * [2026-07-29] This used to also have a "round" shape for ActiveMission's
 * speech-bubble avatar, but that was reverted back to the Hero's own photo
 * per direct user request ("use the user pic wherever there is a speech
 * bubble") -- removed here since it's now unused everywhere.
 * [2026-08-18] Briefly recolored these images from black to beige via a CSS
 * mask (for a since-abandoned attempt at using small mascot copies as
 * TabBar.jsx's tab icons), then reverted per direct clarification -- these
 * full-size panel mascots stay their original black; TabBar.jsx now uses
 * its own self-contained vector icon set instead of mascot art at all.
 * Back to a plain <img>, exactly as before either detour.
 */
const Mascot = ({ variant, className = "" }) => {
  const image = MASCOT_IMAGES[variant];

  return (
    <div className={`comic-mascot--portrait ${className}`} title={MASCOT_LABELS[variant] || variant}>
      {image ? (
        <img src={image} alt="" className="comic-mascot__image" />
      ) : (
        <svg viewBox="0 0 24 24" width={ICON_SIZE} height={ICON_SIZE} className="comic-mascot__icon" aria-hidden="true">
          {MASCOT_FALLBACK_ICONS[variant] || DEFAULT_FALLBACK_ICON}
        </svg>
      )}
    </div>
  );
};

export default Mascot;
